import apiClient from '@u/apiClient'
import AddSendRecordToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddSendRecordToInvoiceController'
import AddItemsToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddItemsToInvoiceController'
import AddItemDossierToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddItemDossierToInvoiceController'
import AddItemDossiersToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddItemDossiersToInvoiceController'
import GetItemsFromAutomationController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetItemsFromAutomationController'
import GetItemsDossierController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetItemsDossierController'
import GetItemsByEventsPlaceDossierController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetItemsByEventsPlaceDossierController'
import AddPacksToInvoiceController from '@/wayfinder/actions/App/Http/Controllers/Invoice/AddPacksToInvoiceController'
import UpdateInvoiceItemController from '@/wayfinder/actions/App/Http/Controllers/InvoiceItem/UpdateInvoiceItemController'
import UpdateAccountingCodeInvoiceItem from '@/wayfinder/actions/App/Http/Controllers/Invoice/UpdateAccountingCodeInvoiceItem'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

// import router from "@/router";

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  async fetchNewInvoiceSendRecord({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetNewModelController.get({ query: { model: 'invoiceSendRecord' } })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storeInvoiceSendRecord({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddSendRecordToInvoiceController.post({
            invoice: payload.invoice_id
          }),
          payload.send_record
        )
        .then((response) => {
          // processSuccessCallback(payload)
          if (response.status === 200) {
            console.log(response.data.invoice)
            commit('setInvoice', response.data.invoice)
            commit('setInvoiceMetadata', response.data.metadata)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  addItemsToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemsToInvoiceController.post({ invoice: payload.invoice_id }),
          payload.data
        )
        .then(async (response) => {
          if (response.status === 200) {
            await commit('setInvoice', response.data.invoice)
            processSuccessCallback(payload)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addItemDossierToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemDossierToInvoiceController.post({
            invoice: payload.invoice_id
          }),
          payload.data
        )
        .then(async (response) => {
          await commit('setInvoice', response.data.invoice)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addItemDossiersToInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemDossiersToInvoiceController.post({
            invoice: payload.invoice_id
          }),
          payload.data
        )
        .then(async (response) => {
          if (response.status === 200) {
            await commit('setInvoice', response.data.invoice)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchAutomationsItems: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetItemsFromAutomationController.get({ invoice: payload.invoice_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchDossierItems: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemsDossierController.get({ invoice: payload.invoice_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchWikiItems: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetItemsByEventsPlaceDossierController.get({
            invoice: payload.invoice_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async addPackToInvoice({ commit }, payload) {
    await apiClient
      .route(
        AddPacksToInvoiceController.post({ invoice: payload.invoice_id }),
        payload.data
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  // ci dessous devrait disparaitre
  async updateInvoiceItem({ commit }, payload) {
    await apiClient
      .put(
        `/api/invoicing/add-item-fast/${payload.invoice_id}`,
        payload.content
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  // ci dessous devrait disparaitre
  async updateInvoiceDossierItem({ commit }, payload) {
    await apiClient
      .put(`/api/invoicing/add-item-fast/${payload.invoice_id}`, {
        dossier_id: payload.dossier_id,
        item_dossier_id: payload.dossier_item_id
      })
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },
  // ci dessous devrait disparaitre
  async updateMultipleInvoiceItems({ commit }, payload) {
    await apiClient
      .put(
        `/api/invoicing/add-multiple-items/${payload.invoice_id}`,
        payload.items
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setInvoice', response.data.invoice)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('', reason)
      })
  },

  updateSingleInvoiceItem: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateInvoiceItemController.put({
            invoice: payload.invoice_id,
            invoice_item: payload.id
          }),
          payload.invoice_item,
          {
            params: {
              for_invoice: payload.for_invoice
            }
          }
        )
        .then((response) => {
          if (payload.for_invoice) {
            commit('setInvoice', response.data.invoice)
          } else {
            commit('setInvoiceItemIndex', response.data.invoice_items)
            commit('setInvoiceItemsMetadata', response.data.metadata)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateAccountingCodeInvoiceItem: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateAccountingCodeInvoiceItem.put({
            invoice: payload.invoice_id,
            invoice_item: payload.id
          }),
          payload.payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
